export default __webpack_public_path__ + "static/media/s7-img.4b622f34.png";